export enum PaymentOptionsEnum {
  ON_SITE = 'PREPAY',
  ONLINE = 'GENERIC_CC'
}
